export enum Authority { 
    LOGIN = 'LOGIN', ADMIN = 'ADMIN', RESTAURANT_VIEW = 'RESTAURANT_VIEW', HELP_1 = 'HELP_1', UPDATE = 'UPDATE',
    CRADLEPOINT_PRO = 'CRADLEPOINT_PRO', INTL = 'INTL', DFS = 'DFS'
}